import { JOB_COMPLETED_MESSAGE } from '../async-job-base/async-job-base.dialog';

export abstract class CopyFormDialogBase {
    // Properties.
    protected formCopyName: string = null;
    protected copyInProgress: boolean = false;
    protected copyErrorOccurred: boolean = false;

    // Constructor.
    public constructor() {

    }

    // Methods available to derived
    // class TypeScript andHTML code.
    public get FormCopyName(): string {
        return (this.formCopyName);
    }
    public set FormCopyName(formCopyNameParam: string) {
        this.formCopyName = formCopyNameParam;

        return;
    }

    public get CopyInitiated(): boolean {
        return (this.copyInProgress);
    }

    public get CopyStatus(): string {
        let status: string = null;

        if (!this.copyInProgress) {
            // Copy has not started.
            status = 'Not started';
        } else if (this.copyInProgress) {
            // A copy job is in progress.
            status = 'Copy in progress';
        } else if (!this.copyErrorOccurred) {
            // A copy completed without error.
            status = JOB_COMPLETED_MESSAGE;//'Completed';
        } else {
            // A copy error occurred.
            status = 'A copy error occurred';
        }

        return (status);
    }
}
